import { Title } from '@angular/platform-browser';
import {
  Component,
  OnInit,
  NgZone,
  ViewChild,
  AfterViewInit,
  ElementRef,
  HostListener,
  ChangeDetectionStrategy
} from '@angular/core';
import { LiveService } from '@components/live/live.service';
import { configMessage } from '@shared/config-message';

import { environment } from '@myenv/environment';
import { SharedService } from '@shared/shared.service';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { PlaceModule } from '@components/places/places.module';
import { PlaceService } from '@components/places/places.service';
import { DataService } from '@components/data/data.service';
import * as FileSaver from 'file-saver';
import { Observable } from 'rxjs';
import { GraphicReportsService } from '@myproject/components/graphic-reports/graphic-reports.service';
declare var $: any;

export let browserRefresh = false;

@Component({
    selector: 'app-location-history',
    templateUrl: './location-history.component.html',
    styleUrls: ['./location-history.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LocationHistoryComponent implements OnInit {
  public distanceMetrics = environment.distanceMetrics;
  staticReports = configMessage.staticReports;
  messageTypeArray: any = [];
  searchModel: any = {};
  markers = [];
  public dateFormat = environment.smallDateFormat;
  public noSecondsTimeFormat = environment.noSecondsTimeFormat;
  public AL_SystemReport = environment.AL_SystemReport;
  tripAuthorities: any = [];
  places: any = [];
  line: any = [];
  latencyData = {
    gsmStrength: '',
    eventTime: '',
    ingestionTimestamp: ''
  };
  origin: {};
  vehicle: any = {
    deviceId: null,
    startTime: null,
    endTime: null
  };
  viewPage = false;
  show = true;
  liveHistoryKey: any;
  locationTotalCount: any;
  openDatePopup: Boolean = false;
  livehistorySearchheader: any = [];
  page = 0;
  pageVehicleHistory = 0;
  isLoading = false;
  rows = [];
  historyRows: any = [];
  temp: any = [];
  liveHistorykeyString: String;
  enablePageVehicleHistory = true;
  liveHistoryAttribute = configMessage.liveHistoryAttribute;
  csvLiveHistPrefKeyArray = [];
  csvLiveHistPrefHeaderArray = [];
  pageCount: any;
  startTime: any;
  endTime: any;
  endPacket = false;
  toggleEffect = false;
  loadingIndicator = true;
  polyLineData: any = [];
  timer: any;
  currentPageCount: any = {
    start: 0,
    end: 0
  };
  cityCircle: any;
  multipleCircles: any = [];
  public resSizeenv = environment.resSize;
  readonly resSize = this.resSizeenv;
  map: google.maps.Map;
  @ViewChild('gmap') gmapElement: any;
  pageInfo = {
    offset: 0,
    count: 0,
    limit: 3,
    pageSize: 0,
    lastPage: 0,
  };
  prevResponse = 0;
  flightPath: any;
  markerscluster = [];
  permissionModules: any = [];
  infowindow;
  locationVehicles: any;
  historyRowsEmpty: Boolean = false;
  filterplace: Boolean = false;
  alerts: any;
  usingEventTime = false;
  selectedFilter = '';
  liveSearch = '';
  liveKey = '';
  hideCalendar = false;
  reportsMenu: any = [];
  reports: any = [];
  selectedVehicle: any = {};
  dottedEvents: any = {
    checked: false
  };
  querySelectVehicle = null;
  customLoader: Boolean = false;
  @ViewChild('infowindowData') infowindowData: ElementRef;
  totalDistanceTravelled = 0;
  // message JSON popup
  messageJsonLoader = false;
  messageJsonRaw: any;
  messageJsonFormattedString: any;
  // message type side drawer
  isDrawerOpen = false;
  messagesLoading = false;
  messages: any = [];
  messageTypeColor = configMessage.messageTypeColor;
  selectedMessages = [];
  messageMarkers: any = {};
  obdLocation = 'locationHistory';
  // when no devices available
  noDevices = true;
  initialDataLoad: Boolean = true;
  timeSeeker = {
    selected: false,
    ts: null,
    te: null,
    selectedVal: [],
    len: 0
  };

  // draggable
  updateChrt = 0;
  graphContainerParams = null;
  currentView = 0;

  constructor(
    private placeService: PlaceService,
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private liveService: LiveService,
    private ngzone: NgZone,
    private dataService: DataService,
    private title: Title,
    private reportsService: GraphicReportsService,
    public element: ElementRef
  ) {
    window["loc"] = this;
  }

  ngOnInit() {
    sessionStorage.clear();
    this.title.setTitle('Location History' + environment.title_text);
    this.permissionModules = JSON.parse(localStorage.getItem('permissionModules'));
    const modules = JSON.parse(localStorage.getItem('accessRoleModules'));
    const tripRoleModule = modules.find(module => module.name === 'TRIPS');
    this.tripAuthorities = tripRoleModule && tripRoleModule.authorities ? tripRoleModule.authorities : [];
    if (this.permissionModules.includes('PLACE')) {
      this.getAllPlace('0');
    }
    this.vehicle = JSON.parse(localStorage.getItem('defaultselectvehicle'));
    this.liveSearch = this.route.snapshot.queryParams.liveSearch;
    this.liveKey = this.route.snapshot.queryParams.liveKey;
    if (!this.vehicle) {
      const vehiclesSubsc = this.sharedService.getAllDevices();
      vehiclesSubsc.subscribe({
        next: res => {
          if (res.length) {
            localStorage.setItem('defaultselectvehicle', JSON.stringify(res[0]));
            $('#mapdiv').css('display', 'flex');
            this.vehicle = res[0];
            this.noDevices = false;
            this.setTime();
          } else {
            this.noDevices = true;
            $('#mapdiv').hide();
          }
        },
        error: error => {
          this.sharedService.getErrorMsg(error);
        }
      });
    } else {
      this.noDevices = false;
      $('#mapdiv').css('display', 'flex');
      this.setTime();
    }
    // this.getMessageType();
    let localData = JSON.parse(localStorage.getItem("preferences"));
    try {
      if (localData["liveHistory"]["toggle"]["tripsView"]) {
        this.goToTrips();
      }
      else if (localData["liveHistory"]["toggle"]["networkLatency"]) {
        this.dottedEvents.checked = localData["liveHistory"]["toggle"]["networkLatency"];
        this.plotDottedLine();
      }
    } catch (e) {
      console.error(e);
    }
    var divOverlay = document.getElementById("draggable");
    if (divOverlay) {
      var isDown = false;
      divOverlay.addEventListener('mousedown', function (e) {
        isDown = true;
      }, true);

      document.addEventListener('mouseup', function () {
        isDown = false;
      }, true);
      let that = this;

      document.addEventListener('mousemove', function (event) {
        event.preventDefault();
        if (isDown) {
          var deltaX = event.movementX;
          var deltaY = event.movementY;
          console.log(deltaY);
          var s1 = $('.col-md-4.pr-0').css('max-height');
          var s2 = $('#map').height();
          var s3 = $('#drawerContent').height();
          s1 = parseInt(s1);
          s2 = parseInt(s2);
          var invh = ((100 * s2) / window.innerHeight);
          var invh1 = ((100 * s3) / window.innerHeight);
          invh = Math.round(invh);
          invh1 = Math.round(invh1);
          let px = s3 / invh1;
          let inc = 100;
          // && (invh + invh1) <= 76 && ((invh1 - inc) >= 1)
          if (deltaY > 0) {
            // $('#drawerContent').css('height', (invh1 - inc).toString() + 'vh');
            // $('.col-md-4.pr-0').css('max-height', (invh + inc).toString() + 'vh');
            // $('#map').css('height', (invh + inc).toString() + 'vh');
            $('#drawerContent').css('height', (invh1 - 100).toString() + 'px');
            $('.col-md-4.pr-0').css('max-height', (invh + inc).toString() + 'px');
            $('#map').css('height', (invh + inc).toString() + 'px');
            // $('.col-md-4.pr-0').css('max-height', (s2 - invh).toString() + 'px');
            // $('#map').css('height', (s2 - invh).toString() + 'px');
            // $('.sectn1').css('height', s4 - (invh + 58));
            // $('.sectn2').css('height', s4 - (invh + 58));
            // && (invh + invh1) <= 76 && ((invh - inc) >= 1)
          } else if (deltaY < 0) {
            $('.col-md-4.pr-0').css('max-height', (invh - inc).toString() + 'px');
            $('#map').css('height', (invh - inc).toString() + 'px');
            $('#drawerContent').css('height', (invh1 + inc).toString() + 'px');
            // $('.col-md-4.pr-0').css('max-height', (s2 ).toString() + 'px');
            // $('#map').css('height', (invh1).toString() + 'vh');
            // $('.sectn1').css('height', s4 + (invh - 58));
            // $('.sectn2').css('height', s4 + (invh - 58));
          }
          that.updateChrt++;
          isDown = true;
          // that.updateChrt = false;
          // var rect = divOverlay.getBoundingClientRect();
          // divOverlay.style.left = rect.x + deltaX + 'px';
          // divOverlay.style.top  = rect.x + deltaX + 'px';
          // isDown = false;
        }
      }, false);
    }
  }


  triggerDynamicService(p1) {
    this.currentView = p1;
    // this.sharedService.setOBDHeight(window.innerWidth, window.innerHeight, this.currentView);
  }

  updateChart(p1) {
    this.updateChrt = p1;
  }

  setTime() {
    if (!this.vehicle.eventTime) {
      this.vehicle.eventTime = this.vehicle.lastCommunication ? this.vehicle.lastCommunication : new Date().toUTCString();
    }
    const endTime = Date.parse(this.vehicle.eventTime);
    const startTime = endTime - (1000 * 60 * 60 * 4);
    this.vehicle.startTime = startTime;
    this.vehicle.endTime = endTime;
    this.startTime = startTime;
    this.endTime = endTime;
    this.usingEventTime = true;
    // this.getMessageType();
    let localData = JSON.parse(localStorage.getItem("preferences"));
    try {

      if (localData["liveHistory"]["toggle"]["tripsView"]) {
        this.goToTrips();
      }
      else if (localData["liveHistory"]["toggle"]["networkLatency"]) {
        this.dottedEvents.checked = localData["liveHistory"]["toggle"]["networkLatency"];
        // this.updateToggle(true, false);
        // this.switchMap();
        this.plotDottedLine();
        // this.setDotsBounds();
      }
    } catch (e) {
      console.error(e);
    }
  }

  getQueryVehicle(name) {
    this.sharedService.onSearchVehicle('assetName', name).subscribe(res => {
      if (res.length) {
        this.querySelectVehicle = res[0];
        this.vehicle = this.querySelectVehicle;
        this.selectedVehicle = this.querySelectVehicle;
        if (this.vehicle.architectureType) this.getMessageType(this.vehicle.architectureType);
        if (res.length && this.querySelectVehicle.lastCommunication) {
          this.vehicle.eventTime = this.querySelectVehicle.lastCommunication;
          const endTime = Date.parse(this.vehicle.eventTime);
          const startTime = endTime - (1000 * 60 * 60 * 4);
          this.vehicle.startTime = startTime;
          this.vehicle.endTime = endTime;
          this.startTime = startTime;
          this.endTime = endTime;
          this.usingEventTime = true;
          this.getAllData();
        } else {
          this.historyRows = 0;
          this.historyRowsEmpty = true;
          this.locationTotalCount.count = 0;
          this.alerts = [];
          this.locationVehicles = 0;
          this.totalDistanceTravelled = 0;
          const endTime = Date.parse(new Date().toUTCString());
          const startTime = endTime - (1000 * 60 * 60 * 4);
          this.vehicle.startTime = startTime;
          this.vehicle.endTime = endTime;
          this.mapInit();
        }
      }
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }

  getMessageType(architectureType) {
    this.dataService.getMessageType(architectureType).subscribe({
      next: res => {
        this.messageTypeArray = res;
        // this.searchModel.messageType = this.messageTypeArray[0].messageType;
      },
      error: error => {
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  getMessageJSON(messageId) {
    this.messageJsonLoader = true;
    this.dataService.getMessage(messageId).subscribe((res: any) => {
      this.messageJsonLoader = false;
      this.messageJsonRaw = JSON.stringify(res, null, 4);
      this.messageJsonFormattedString = this.sharedService.syntaxHighlight([res]);
    }, error => {
      this.messageJsonLoader = false;
      this.sharedService.getErrorMsg(error);
    });
  }

  getFilteredMessage() {
    this.page = 0;
    this.pageVehicleHistory = 0;
    this.pageInfo.offset = 0;
    if (!this.filterplace) {
      // this.getSingleVehicleView(this.vehicle.deviceId, this.startTime, this.endTime, this.searchModel.messageType);
      if (this.timeSeeker.selected) {
        this.getSingleVehicleView(this.vehicle.deviceId, this.timeSeeker.ts, this.timeSeeker.te, this.searchModel.messageType);
      } else {
        this.getSingleVehicleView(this.vehicle.deviceId, this.startTime, this.endTime, this.searchModel.messageType);
      }
      this.getTestCount(this.startTime, this.endTime);
    }
    else {
      this.filterPlaces(this.startTime, this.endTime);
    }
  }

  changeVehicle(e) {
    this.resetTimeSeeker();
    if (localStorage.getItem('defaultselectvehicle') && this.querySelectVehicle == null) {
      this.setItem();
    } else {
      this.selectedVehicle = e ? e.deviceId : null;
      this.querySelectVehicle = e;
      this.vehicle = this.querySelectVehicle;
      this.searchModel.messageType = null;
      this.messageTypeArray = [];
      if (this.querySelectVehicle.lastCommunication) {
        localStorage.setItem('defaultselectvehicle', JSON.stringify(e));
        this.vehicle.eventTime = this.querySelectVehicle.lastCommunication;
        this.usingEventTime = true;
        this.onTimeChange();
        this.getQueryVehicle(this.querySelectVehicle.assetName);
      } else {
        localStorage.setItem('defaultselectvehicle', JSON.stringify(e));
        this.historyRows = 0;
        this.historyRowsEmpty = true;
        this.locationTotalCount.count = 0;
        this.alerts = [];
        this.locationVehicles = 0;
        this.totalDistanceTravelled = 0;
        const endTime = Date.parse(new Date().toUTCString());
        const startTime = endTime - (1000 * 60 * 60 * 4);
        this.vehicle.startTime = startTime;
        this.vehicle.endTime = endTime;
        this.startTime = startTime;
        this.endTime = endTime;
        this.mapInit();
      }
    }
    //  get selected Vehicle Data
  }

  getAllData() {
    this.page = 0;
    this.pageVehicleHistory = 0;
    this.pageInfo.offset = 0;
    this.getPermissionsLiveHistory();
    // this.getAlerts(this.startTime, this.endTime);
    if (this.dottedEvents.checked) {
      if (this.initialDataLoad) {
        this.getmapPolyline(this.startTime, this.endTime);
      }
      this.initialDataLoad = false;
      this.plotDottedLine();
    } else {
      this.getmapPolyline(this.startTime, this.endTime);
    }
    // this.plotDottedLine();
    if (this.filterplace) {
      this.filterPlaces(this.startTime, this.endTime);
    } else {
      if (this.timeSeeker.selected) {
        this.getSingleVehicleView(this.vehicle.deviceId, this.timeSeeker.ts, this.timeSeeker.te);
      } else {
        this.getSingleVehicleView(this.vehicle.deviceId, this.startTime, this.endTime);
      }
      this.getTestCount(this.startTime, this.endTime);
    }
    this.selectedMessages = [];
    this.clearAllMessageMarkers();
    this.messageMarkers = {};
    if (this.isDrawerOpen) this.getAllMessagesWithCount();


  }

  setItem() {
    const liveSelectedVehicle = JSON.parse(localStorage.getItem('defaultselectvehicle'));
    this.getQueryVehicle(liveSelectedVehicle.assetName);
  }

  ngAfterViewInit() {
    this.mapInit();
    // this.vehicle = this.querySelectVehicle;
    // this.vehicle.eventTime = this.querySelectVehicle.lastCommunication;
    // const endTime = Date.parse(this.vehicle.eventTime);
    // const startTime = endTime - (1000 * 60 * 60 * 4);
    // this.vehicle.startTime = startTime;
    // this.vehicle.endTime = endTime;
    // this.getmapPolyline(this.vehicle.startTime, this.vehicle.endTime);
    // this.vehicle.deviceId = this.route.snapshot.queryParams.id;
  }

  onTimeChange(e?) {
    this.resetTimeSeeker();
    if (e) {
      this.page = 0;
      this.pageInfo.offset = 0;
      this.usingEventTime = false;
      this.startTime = e.startTime;
      this.endTime = e.endTime;
      this.pageVehicleHistory = 0;
      this.enablePageVehicleHistory = true;
      this.viewPage = true;
      this.locationVehicles = [];
      this.mapInit();
      this.getAllData();
    } else {
      const endTime = Date.parse(this.vehicle.eventTime);
      const startTime = endTime - (1000 * 60 * 60 * 4);
      this.vehicle.startTime = startTime;
      this.vehicle.endTime = endTime;
      this.startTime = startTime;
      this.endTime = endTime;
    }
  }

  // Google maps start
  mapInit() {
    var mapOptionObject = {
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      zoom: 4,
      minZoom: 4,
      maxZoom: 21,
      mapTypeControl: true,
      mapTypeControlOptions: {
        position: google.maps.ControlPosition.BOTTOM_CENTER
      },
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT
      },
      scaleControl: true,
      streetViewControl: false,
      // streetViewControlOptions : {
      // position : google.maps.ControlPosition.TOP_RIGHT
      // },
      fullscreenControl: false,
      clickableIcons: false,
      center: {
        lat: environment.lat,
        lng: environment.lng
      }
    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapOptionObject);
  }

  plotCircle(place) {
    const location = { lat: place.circle.centre[0], lng: place.circle.centre[1] };
    this.cityCircle = new google.maps.Circle({
      strokeColor: place.color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: place.color,
      fillOpacity: 0.35,
      map: this.map,
      center: location,
      radius: place.circle.radius,
      editable: false
    });
    let latlng = new google.maps.LatLng(location.lat, location.lng);
    let bounds = new google.maps.LatLngBounds();
    bounds.extend(latlng);
    this.multipleCircles.push(this.cityCircle);
    // this.map.fitBounds(this.cityCircle.getBounds());
  }

  addPolyline(data) {
    let flightPlanCoordinates = [];
    let bounds = new google.maps.LatLngBounds();
    data.forEach(item => {
      let latLngObj = {};
      if (item.latitude && item.longitude) {
        latLngObj['lat'] = item.latitude;
        latLngObj['lng'] = item.longitude;
        flightPlanCoordinates.push(latLngObj);
        // to extends the bounds
        bounds.extend(new google.maps.LatLng(item.latitude, item.longitude));
      }
    });
    this.createpolyLineChunks(flightPlanCoordinates);
    this.map.fitBounds(bounds);
  }

  createpolyLineChunks(flightPlanCoordinates) {
    if (flightPlanCoordinates.length >= 12) {
      // let colors = ['#420d29','#891C56', '#d22b83', '#ffd5eb'];
      // let colors = ['#08fc49','#dbfc08','#fce408','#fc3508'];
      let colors = [
        '#FF0000',
        '#E81700',
        '#D12E00',
        '#B94600',
        '#A25D00',
        '#8B7400',
        '#748B00',
        '#5DA200',
        '#46B900',
        '#2ED100',
        '#17E800',
        '#00FF00'
      ];
      let arrayCount = Math.floor(flightPlanCoordinates.length / colors.length);
      for (let i = 1; i <= colors.length; i++) {
        let firstPoint = 1;
        let endPoint = arrayCount;
        if (i != 1) {
          firstPoint = arrayCount * (i - 1);
          if (i == colors.length) {
            endPoint = flightPlanCoordinates.length;
          } else {
            endPoint = arrayCount * i;
          }
        }
        this.chunkArray(firstPoint, flightPlanCoordinates, endPoint);
        this.flightPath = new google.maps.Polyline({
          path: this.polyLineData,
          geodesic: true,
          strokeColor: colors[i - 1],
          strokeOpacity: 0.8,
          strokeWeight: 3
        });
        this.flightPath.setMap(this.map);
        this.line.push(this.flightPath);
      }
    } else {
      this.flightPath = new google.maps.Polyline({
        path: flightPlanCoordinates,
        geodesic: true,
        strokeColor: '#891d56',
        strokeOpacity: 0.8,
        strokeWeight: 3
      });
      this.flightPath.setMap(this.map);
      this.line.push(this.flightPath);
    }
  }


  chunkArray(firstCount, myArray, chunk_size) {
    var res = [];
    let i;
    let temp = [];
    for (i = firstCount - 1; i < chunk_size; i++) {
      temp.push(myArray[i]);
    }
    this.polyLineData = temp;
  }

  // To add a marker in the map
  addMarker(data) {
    let localDate = new Date(data.eventTime);
    var datePipe = new DatePipe('en-US');
    let eventDate = datePipe.transform(data.eventTime, 'MMM d, h:mm:ss a');
    var latlng = new google.maps.LatLng(data.latitude, data.longitude);
    var marker = new google.maps.Marker({
      position: latlng,
      map: this.map,
      label: eventDate,
      icon: data.iconUrl.url
    });
    this.markers.push(marker);
  }


  // To add a marker in the map
  addDots(data) {
    const bounds = new google.maps.LatLngBounds();
    var latlng = new google.maps.LatLng(data.latitude, data.longitude);
    var marker = new google.maps.Marker({
      position: latlng,
      map: this.map,
      icon: data.iconUrl
    });
    this.markers.push(marker);
    let global = this;
    // if (data.ingestionTimestamp) {
    google.maps.event.addListener(marker, 'mouseover', function () {
      global.latencyData = data;
      this.infowindow = new google.maps.InfoWindow();
      this.infowindow.setContent(data.ingestionTimestamp && global.infowindowData.nativeElement);
      this.infowindow.open(global.map, marker);
    });
    google.maps.event.addListener(marker, 'mouseout', function () {
      this.infowindow.close();
    });
    // }
    // if(this.locationVehicles.length <= 1) {
    //   bounds.extend(latlng);
    //   this.map.fitBounds(bounds);
    // } else {
    //   this.map.setZoom(5);
    //   this.map.setCenter({ lat: environment.lat, lng: environment.lng });
    // }
  }

  setDotsBounds() {
    const bounds = new google.maps.LatLngBounds();
    for (let u in this.locationVehicles) {
      if (u) {
        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(this.locationVehicles[u].latitude,
            this.locationVehicles[u].longitude),
        });
        bounds.extend(marker.getPosition());
      }
    }
    this.map.fitBounds(bounds);
  }

  setMapOnAll(map) {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(map);
    }
  }

  clearMarkers() {
    this.setMapOnAll(null);
  }

  clearPolyline() {
    for (var i = 0; i < this.line.length; i++) {
      this.line[i].setMap(null);
    }
  }

  // To display the label and message on hovering the marker
  markerHover(marker) {
    var theme = marker.themeName;
    var contentString = '<div id="content" class=' + theme + '>' +
      '<p class="firstHeading">' + marker.label + '</p>' +
      '<p style="margin-bottom: 0; font-size: 12px">' + marker.messageType + '</p>' +
      // '<p>'+ marker.eventType+'</p>'+
      '</div>';

    var infowindow = new google.maps.InfoWindow({
      content: contentString
    });
    marker.addListener('mouseover', function () {
      infowindow.open(this.map, marker);
    });
    marker.addListener('mouseout', () => infowindow.close())
  }

  // To add clusters for vehicles
  addCluster(liveVehicles) {
    this.markerscluster = [];
    liveVehicles.forEach((item, index) => {
      if (item.latitude && item.longitude) {
        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(item.latitude, item.longitude),
          label: item.eventType,
          icon: item.iconUrl.url
        });
        marker['themeName'] = item.themeName;
        marker['messageType'] = item.messageType;
        marker['eventType'] = item.eventType;
        this.markerHover(marker);
        this.markerscluster.push(marker)
      }
    });
    // Add a marker clusterer to manage the markers.
    const IMAGE_PATH = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
    const renderer = {
      render: ({ count, position }) => {
        const index = Math.min(5, Math.floor(count / 10) + 1);
        return new google.maps.Marker({
          position: position,
          label: {
            text: String(count),
            color: 'white',
            fontSize: '14px',
          },
          icon: {
            url: `${IMAGE_PATH}${index}.png`,
            scaledSize: new google.maps.Size(53, 53),
            anchor: new google.maps.Point(26, 26),
          },
          zIndex: 1000 + count,
        });
      }
    } as any;
    const markerCluster = new MarkerClusterer({
      map: this.map,
      markers: this.markerscluster,
      renderer,
    });
    this.markerscluster.push(markerCluster);
  }
  // Google maps ends

  // To get preferences and permissions
  getPermissionsLiveHistory() {
    this.liveHistoryKey = [];
    if (localStorage['liveHistoryPrefrence']) {
      const liveHistoryPrefrence = JSON.parse(localStorage.getItem('liveHistoryPrefrence'));
      this.livehistorySearchheader = liveHistoryPrefrence;
      this.liveHistoryKey = liveHistoryPrefrence.map(function (data) {
        return data.key;
      })
      if (this.liveHistoryKey.length) {
        this.liveHistorykeyString = this.liveHistoryKey.toString().concat(',').concat(this.liveHistoryAttribute);
      } else {
        this.liveHistorykeyString = this.liveHistoryAttribute;
      }
    } else {
      this.liveHistorykeyString = this.liveHistoryAttribute;
      this.livehistorySearchheader = '';
    }
  }

  // To get data for specific vehicle
  getSingleVehicleView(deviceId, startTime, endTime, messageType?) {
    try {
      this.enablePageVehicleHistory = true;
      this.loadingIndicator = true;
      this.viewPage = true;
      this.getPermissionsLiveHistory();
      if (this.pageVehicleHistory == 0) {
        this.historyRows = [];
      }
      if (deviceId) {
        if (this.timeSeeker.selected) {
          this.getMessages(this.vehicle.deviceId, this.timeSeeker.ts, this.timeSeeker.te);
        } else {
          this.getMessages(deviceId, startTime, endTime, messageType);
        }
      }
    } catch (e) {
      console.log(e.message);
    }
  }

  // Setting data limit for table in each page
  setPageInfo() {
    this.pageInfo.count = this.historyRows.length;
    let pagecount = this.pageInfo.count / this.pageInfo.limit;
    this.pageInfo.lastPage = Math.floor(pagecount);
    let decimal = pagecount - this.pageInfo.lastPage;

    if (!Number.isInteger(decimal)) {
      this.pageInfo.lastPage = this.pageInfo.lastPage + 1;
    }
    if (this.pageVehicleHistory == 0) {
      if (this.historyRows.length) {
        this.currentPageCount.start = (this.pageInfo.offset * this.pageInfo.pageSize) + 1;
        if (this.historyRows.length <= 10) {
          this.currentPageCount.end = this.pageInfo.count;
        } else {
          this.currentPageCount.end = (this.pageInfo.offset * this.pageInfo.pageSize) + this.pageInfo.limit;
        }
      }
    }
  }

  pageCallback(value) {
    this.pageInfo.offset = value.offset;
    this.currentPageCount.start = (value.offset * value.pageSize) + 1;
    const lastPage = Math.floor(this.historyRows.length / 10);
    if (lastPage == value.offset) {
      this.currentPageCount.end = value.count;
    } else {
      this.currentPageCount.end = (value.offset * value.pageSize) + value.limit;
    }
    // if (this.pageCount == 100) {
    if (this.pageInfo.lastPage == (this.pageInfo.offset + 1)) {
      if (this.prevResponse == 100) {
        this.pageVehicleHistory = ++this.pageVehicleHistory;
        // if (this.usingEventTime) {
        //   this.getSingleVehicleView(this.vehicle.deviceId, this.vehicle.startTime, this.vehicle.endTime);
        // } else {
        if (this.timeSeeker.selected) {
          this.getSingleVehicleView(this.vehicle.deviceId, this.timeSeeker.ts, this.timeSeeker.te);
        } else {
          this.getSingleVehicleView(this.vehicle.deviceId, this.startTime, this.endTime);
        }
        // }
      }
    }
    // }
  }

  // Redirect to live page on clicking the back button
  back() {
    this.router.navigate(['/live'], {
      queryParams: {
        searchBy: this.liveKey,
        value: this.liveSearch
      }
    });
  }

  onScroll(e) {
    console.log(e.currentTarget.scrollTop);
    console.log('Bottom', e.currentTarget.scrollBottom)
    const footer = $('datatable-footer');
    const overflowDiv = $('.col-md-4.pr-0');
    const subDiv = $('.liveTable').height();
    const distance = $('.col-md-6.pl-1.animated.fadeIn').height();
    if (footer.length) {
      // const height = $('.liveTable').height() - (e.currentTarget.scrollTop + 160);
      const height = (e.currentTarget.scrollTop + $('datatable-footer').height() + distance + parseInt($('datatable-body').css('marginBottom') + 30)) - subDiv;
      // const height = (e.currentTarget.scrollTop + overflowDiv.height()) - ($('.liveTable').height());
      // footer.css({
      //   'position': 'absolute',
      //   'z-index': 10,
      //   'margin-top': (height).toString() + 'px'
      // });
    }
  }

  move(p) {
    let s1 = $('.col-md-4.pr-0').css('max-height');
    let s2 = $('#map').height();
    let s3 = $('#drawerContent').height();
    let s4 = $('.sectn1').height();
    s1 = parseInt(s1);
    s2 = parseInt(s2);
    if (p === '+') {
      // $('.col-md-4.pr-0').css('max-height', s1 + 5);
      // $('#map').css('height', s1 - 5);
      $('.col-md-4.pr-0').css('max-height', s1 + 50);
      $('#map').css('height', s1 + 50);
      $('#drawerContent').css('height', (s3 - 50).toString() + 'px');
      $('.sectn1').css('height', s4 - 50);
      $('.sectn2').css('height', s4 - 50);
    } else {
      $('.col-md-4.pr-0').css('max-height', s1 - 50);
      $('#map').css('height', s1 - 50);
      $('#drawerContent').css('height', (s3 + 50).toString() + 'px');
      $('.sectn1').css('height', s4 + 50);
      $('.sectn2').css('height', s4 + 50);
    }
  }

  /*Polyline and marker creation method starts*/
  getmapPolyline(startTime, endTime) {
    this.liveService.getPolylineData(this.vehicle.deviceId, startTime, endTime).subscribe(res => {
      if (this.markers.length) {
        this.clearMarkers();
      }
      if (res.events.length > 0) {
        this.plotEvents(res.events);
      }
      this.locationVehicles = res;
      this.totalDistanceTravelled = res.distanceTravelled;
      if (this.vehicle && this.vehicle.generation === 'V2X') {
        if (res.locations.length > 0) {
          var markerUrl = '../../assets/img/direction/v2x.png';
          if (res.locations[0] && res.locations[0].publishedBy === 'OBU Simulation') {
            markerUrl = '../../assets/img/marker_red.png';
          }
          var iconUrl = {
            url: markerUrl,
            labelOrigin: { x: 50, y: -15 }
          }
          res.locations[0].iconUrl = iconUrl;
          this.addMarker(res.locations[0]);
          this.addBounds(res.locations);
        } else {
          this.map.setZoom(4);
        }
      } else {
        if (res.locations.length > 0) {
          if (res.locations[res.locations.length - 1]) {
            const iconUrl = {
              url: '../../assets/img/marker_start.png',
              labelOrigin: { x: 50, y: -15 }
            };
            res.locations[res.locations.length - 1].iconUrl = iconUrl;
            this.addMarker(res.locations[res.locations.length - 1]);
          }
          if (res.locations[0]) {
            const heading = res.locations[0].heading;
            const packet = res.locations[0];
            let icon = '';
            if (packet.messageType) {
              if (packet.messageType === 'COMMUNICATION_LOST') {
                icon = '../../../../assets/img/direction/warning/';
              } else if (packet.messageType === 'TRIP_END' || packet.messageType === 'IGNITION_OFF') {
                icon = '../../../../assets/img/direction/red/';
              } else if (!packet.endPacket && packet.messageType !== 'TRIP_END' && packet.messageType !== 'IGNITION_OFF') {
                icon = '../../../../assets/img/direction/green/';
              } else {
                icon = '../../../../assets/img/direction/gray/';
              }
            } else {
              icon = '../../../../assets/img/direction/default/';
            }
            let iconName = `${icon}stop.png`;
            if (heading || heading == '0') {
              if (heading > 0 && heading <= 30) {
                iconName = `${icon}30.png`;
              } else if (heading > 30 && heading <= 60) {
                iconName = `${icon}60.png`;
              } else if (heading > 60 && heading <= 90) {
                iconName = `${icon}90.png`;
              } else if (heading > 90 && heading <= 120) {
                iconName = `${icon}120.png`;
              } else if (heading > 120 && heading <= 150) {
                iconName = `${icon}150.png`;
              } else if (heading > 150 && heading <= 180) {
                iconName = `${icon}180.png`;
              } else if (heading > 180 && heading <= 210) {
                iconName = `${icon}210.png`;
              } else if (heading > 210 && heading <= 240) {
                iconName = `${icon}240.png`;
              } else if (heading > 240 && heading <= 270) {
                iconName = `${icon}270.png`;
              } else if (heading > 270 && heading <= 300) {
                iconName = `${icon}300.png`;
              } else if (heading > 300 && heading <= 330) {
                iconName = `${icon}330.png`;
              } else if (heading > 330 && heading <= 360 || heading == '0') {
                iconName = `${icon}0.png`;
              }
            }
            const iconUrl = {
              url: iconName,
              labelOrigin: { x: 50, y: -15 }
            };
            res.locations[0].iconUrl = iconUrl;
            this.addMarker(res.locations[0]);
          }
          this.addPolyline(res.locations);
        } else {
          this.map.setZoom(4);
        }
      }
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }
  /*Polyline and marker creation method ends*/

  /*Icon for location markers as per theme*/
  plotEvents(res) {
    var newResponse = res.map(function (data) {
      if (data.themeName) {
        var theme = data.themeName;
        var iconName = '';
        if (theme == 'themeWarning') {
          iconName = '../../assets/img/marker_yellow.png';
        } else if (theme == 'themeDanger') {
          iconName = '../../assets/img/marker_red.png';
        } else if (theme == 'themeInfo') {
          iconName = '../../assets/img/marker_blue.png';
        } else if (theme == 'themeSuccess') {
          iconName = '../../assets/img/marker_green.png';
        } else {
          iconName = '../../assets/img/rect836.png';
        }
        var iconUrl = {
          url: iconName,
          labelOrigin: { x: 50, y: -15 }
        }
      } else {
        var iconUrl = {
          url: '../../assets/img/marker_start.png',
          labelOrigin: { x: 50, y: -15 }
        }
      }
      data.iconUrl = iconUrl;
    })
    this.addCluster(res);
  }

  switchMap() {
    this.dottedEvents.checked = !this.dottedEvents.checked;
    this.updateToggle(this.dottedEvents.checked, false);
    if (this.dottedEvents.checked) {
      this.plotDottedLine();
    } else {
      this.getmapPolyline(this.startTime, this.endTime);
    }
  }

  plotDottedLine() {
    this.liveService.getPolylineData(this.vehicle.deviceId, this.startTime, this.endTime).subscribe(res => {
      // this.locationVehicles = res;
      if (this.markers) {
        this.clearMarkers();
      }
      if (this.line.length) {
        this.clearPolyline();
      }
      this.totalDistanceTravelled = res.distanceTravelled;
      if (res.locations.length > 0) {
        this.locationVehicles = res.locations.filter(item => {
          if (item.ingestionTimestamp) {
            let eventTime = Date.parse(item.eventTime);
            let ingestionTimestamp = Date.parse(item.ingestionTimestamp);
            let timeDiff = ingestionTimestamp - eventTime;
            // let ms = 1000*Math.round(timeDiff/1000); // round to nearest second
            // let d = new Date(ms);
            // let result = d.getUTCMinutes();
            let result = Math.floor((timeDiff / 1000) / 60);
            if (result <= 3) {
              var iconUrl = {
                url: '../../assets/img/location-history-icons/green_circle.png',
                labelOrigin: { x: 50, y: -15 },
                scaledSize: new google.maps.Size(10, 10)
              }
            } else if (result > 3 && result <= 10) {
              var iconUrl = {
                url: '../../assets/img/location-history-icons/orange_circle.png',
                labelOrigin: { x: 50, y: -15 },
                scaledSize: new google.maps.Size(10, 10)
              }
            } else if (result > 10) {
              var iconUrl = {
                url: '../../assets/img/location-history-icons/red_circle.png',
                labelOrigin: { x: 50, y: -15 },
                scaledSize: new google.maps.Size(10, 10)
              }
            }
            item.iconUrl = iconUrl;
            return item;
          }
        })
        this.locationVehicles.map(item => {
          this.addDots(item);
        })
        this.setDotsBounds();
      }
      else {
        this.map.setZoom(4);
      }
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }

  // To download vehicle data as a csv file
  getHistoryCsvHeaderData() {
    // Getting the liveHistoryPrefrence and the default list of liveAttribute and creating a CSV Header Array after removing the duplicates
    // const defaultLiveHistoryArray = this.liveHistoryAttribute.split(',');
    const liveHistoryPreference = JSON.parse(localStorage.getItem('liveHistoryPrefrence'));
    if (localStorage['liveHistoryPrefrence']) {
      const liveHistoryPrefKeyArray = liveHistoryPreference.map(data => data.key);
      this.csvLiveHistPrefKeyArray = Array.from(new Set(['eventTime', ...liveHistoryPrefKeyArray]));
      // Creating our User Preferred Header Array with the display names to be shown on the downloaded file
      this.livehistorySearchheader.map(obj => {
        this.csvLiveHistPrefKeyArray.map(keys => {
          if (keys === obj.key) {
            const i = this.csvLiveHistPrefKeyArray.indexOf(keys);
            this.csvLiveHistPrefHeaderArray[i] = obj.displayName;
          }
        });
      });
    } else {
      this.csvLiveHistPrefKeyArray = ['eventTime'];
    }
    this.csvLiveHistPrefHeaderArray[0] = 'Time';
  }

  downloadViewPage() {
    this.getHistoryCsvHeaderData();

    // Build row data respecting selected headers
    const dataRows = this.historyRows.map(vehicle => {
      return this.csvLiveHistPrefKeyArray.map(csvHeader => {
        if (csvHeader === 'eventTime') {
          return moment(vehicle[csvHeader]).format('DD MMM YYYY, hh:mm a');
        }
        return vehicle[csvHeader] || '';
      });
    });

    // Combine header and rows into worksheet data
    const wsData = [this.csvLiveHistPrefHeaderArray, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'LocationHistory');

    const date = new Date();
    const filename = `${this.vehicle.assetName}_${date.toISOString()}_location_history.csv`;

    const csvBuffer = XLSX.write(wb, { bookType: 'csv', type: 'array', FS: ',' });
    const blob = new Blob([csvBuffer], { type: 'text/csv;charset=utf-8;' });
    FileSaver.saveAs(blob, filename);
  }

  downloadMessageJSON() {
    const blob = new Blob([this.messageJsonRaw], {
      type: 'text/json;charset=utf-8'
    });
    FileSaver.saveAs(blob, 'message.json');
  }

  /*location history component search*/
  // updateFilterHistory(event: any) {
  //   const val = event.target.value;
  //   if (val === '') {
  //     this.getSingleVehicleView(this.vehicle.deviceId);
  //   } else {
  //     const temp = this.historyRows.filter(d => {
  //       return ((d.messageType.toLowerCase().indexOf(val) !== -1 || !val) || (d.vehicleSpeed ? (d.vehicleSpeed.toString().indexOf(val) !== -1 || !val) : !val));
  //     });
  //     this.vehicle.trips = temp;
  //     this.historyRows = this.vehicle.trips;
  //   }
  // }

  getAlerts(startTime, endTime) {
    this.isLoading = true;
    this.liveService.getAlerts(this.vehicle.deviceId, startTime, endTime).subscribe(res => {
      this.isLoading = false;
      this.alerts = res;

    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }

  togglePlacesFilter() {
    if (this.filterplace) {
      this.page = 0;
      this.pageInfo.offset = 0;
      this.clearFilter();
    } else {
      // if (this.usingEventTime) {
      //   this.filterPlaces(this.vehicle.startTime, this.vehicle.endTime);
      // } else {
      this.filterPlaces(this.startTime, this.endTime);
      // }
    }
  }

  filterPlaces(startTime, endTime) {
    this.loadingIndicator = true;
    this.filterplace = true;
    this.selectedFilter = 'placeFilter';
    this.liveService.getfilteredPlaces(
      this.vehicle.deviceId, this.pageVehicleHistory, this.liveHistorykeyString, startTime, endTime, this.resSize
    ).subscribe(res => {
      this.ngzone.run(() => {
        if (res.length > 0) {
          if (this.pageVehicleHistory == 0) {
            this.historyRows = [];
          }
          this.historyRowsEmpty = false;
          this.historyRows = [...this.historyRows, ...res];
          this.vehicle.trips = this.historyRows;
          this.vehicle.trips = this.vehicle.trips.map(data => {
            if (data.vehicleSpeed && !Number.isInteger(data.vehicleSpeed)) {
              let newvehicleSpeed = data.vehicleSpeed;
              data.vehicleSpeed = parseFloat(newvehicleSpeed).toFixed(1);
            }
            var messageValue = configMessage.messageType[data.eventType];
            if (!messageValue) {
              messageValue = data.eventType;
            }
            data.activity = `${messageValue} (${data.placeName})`;
            let global = this;
            if (global.places.length) {
              global.places.forEach(placeData => {
                if (data.eventType == 'IN' && data.placeId == placeData.placeId) {
                  data.place = placeData;
                }
              });
              if (data.place) {
                global.plotCircle(data.place);
              }
            }
            return data;
          });
          // To set page Count
          this.setPageInfo();
          this.getPlcesFilterCount(startTime, endTime);
          this.pageCount = res.length;
          this.loadingIndicator = false;

        } else {
          this.currentPageCount = {
            start: 0,
            end: 0
          };
          this.historyRowsEmpty = true;
          this.historyRows = [];
          this.mapInit();
          this.getPlcesFilterCount(startTime, endTime);
          this.mapInit();
        }
      });
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }

  getAllPlace(page) {
    this.isLoading = true;
    this.placeService.getAllPlace(this.page).subscribe(res => {
      this.isLoading = false;
      this.places = res;
      this.temp = res;
      //
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }

  clearFilter() {
    this.selectedFilter = '';
    this.filterplace = false;
    let start = null;
    let end = null;
    // if (this.usingEventTime) {
    //   start = this.vehicle.startTime;
    //   end = this.vehicle.endTime;
    // } else {
    start = this.startTime;
    end = this.endTime;
    // }
    this.pageVehicleHistory = 0
    // this.getSingleVehicleView(this.vehicle.deviceId, start, end);
    if (this.timeSeeker.selected) {
      this.getSingleVehicleView(this.vehicle.deviceId, this.timeSeeker.ts, this.timeSeeker.te);
    } else {
      this.getSingleVehicleView(this.vehicle.deviceId, start, end);
    }
    this.getTestCount(start, end);
    if (this.dottedEvents.checked) {
      this.plotDottedLine();
    } else {
      this.getmapPolyline(this.startTime, this.endTime);
    }
    if (this.multipleCircles.length) {
      this.multipleCircles.forEach(item => {
        item.setMap(null);
      });
    }
  }

  getTestCount(startTime, endTime) {
    // if(!this.searchModel.messageType) {
    this.isLoading = true;
    this.liveService.getTestCount(
      this.vehicle.deviceId, startTime, endTime, this.pageVehicleHistory, this.resSize, this.searchModel.messageType
    ).subscribe(res => {
      this.locationTotalCount = res;
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
    // }
  }

  getPlcesFilterCount(startTime, endTime) {
    this.isLoading = true;
    this.liveService.getPlcesFilterCount(
      this.vehicle.deviceId, startTime, endTime, this.pageVehicleHistory, this.resSize
    ).subscribe(res => {
      this.locationTotalCount = res;
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }

  // to get all Reports
  getallReports() {
    if (localStorage.getItem('reports')) {
      this.reportsMenu = [];
      let reports = JSON.parse(localStorage.getItem('reports'));
      reports.map(obj => {
        if (!obj.hidden) {
          this.reportsMenu.push(obj);
        }
        // this.vehicleDetail = {};
      });
      this.reports = this.reportsMenu;
    } else {
      this.customLoader = true;
      this.sharedService.getReports().subscribe(res => {
        res.map(obj => {
          if (!obj.hidden) {
            this.reportsMenu.push(obj);
          }
          // this.vehicleDetail = {};
        });
        this.staticReports = this.staticReports.filter(item => {
          if (item.reportType === 'system' && item.url.includes('trigger-report') && !this.AL_SystemReport) return false;
          if (item.reportType === 'device' && item.url.includes('trip-summary') && !this.tripAuthorities.includes('READ')) return false;
          if (item.reportType === 'billing' && !this.permissionModules.includes('BILLING')) return false;
          return true;
        });
        this.reportsMenu = [
          ...this.reportsMenu,
          ...this.staticReports
        ];
        localStorage.setItem('reports', JSON.stringify(this.reportsMenu));
        this.customLoader = false;
        this.reports = this.reportsMenu;
      }, error => {
        this.customLoader = false;
        this.sharedService.getErrorMsg(error);
      });
    }
  }

  filterReport(event) {
    const inputVal = event.target.value.toLowerCase();
    const val = inputVal.trim();
    const temp = this.reportsMenu.filter(function (d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    this.reports = temp;
  }

  redirectToReports(report) {
    const vehicle = this.vehicle;
    try {
      localStorage.setItem('currentReport', JSON.stringify(report));
      localStorage.setItem('reportsVehicle', JSON.stringify(vehicle));
      if (report.type === 'VISUALIZATION') {
        this.router.navigate(['/reports/device/visualization']);
      } else if (report.downloadable && report.type !== 'AL_PLANT_MODE') {
        this.router.navigate(['/reports/device/custom']);
      } else if (report.type === 'AL_PLANT_MODE') {
        this.router.navigate(['/reports/device/alPlantMode']);
      } else if (['vehicle', 'device', 'system', 'billing'].includes(report.reportType) || report.name === 'Trip Summary') {
        this.router.navigate([report.url]);
      } else {
        this.router.navigate(['/reports/device/messages']);
      }
    } catch (e) {
      console.log(e.message);
    }
  }

  goToTrips() {
    // const distance = this.locationVehicles ? this.locationVehicles.distanceTravelled : 0;
    this.updateToggle(this.dottedEvents.checked, true);
    this.initialDataLoad = false;
    this.sharedService.goToHistory({
      queryParams: {
        startDate: this.startTime,
        endDate: this.endTime,
        id: this.vehicle.deviceId,
        name: this.vehicle.assetName,
        distance: this.totalDistanceTravelled
      }
    });
  }

  updateToggle(network, trips) {
    let localData = JSON.parse(localStorage.getItem("preferences"));
    localData["liveHistory"]["toggle"] = {};
    localData["liveHistory"]["toggle"]["networkLatency"] = network;
    localData["liveHistory"]["toggle"]["tripsView"] = trips;
    localStorage.setItem("preferences", JSON.stringify(localData));
    this.sharedService.updatePreference({ "liveHistory": { "toggle": localData["liveHistory"]["toggle"] } }).subscribe(data => {
      console.log("data", data);
    })
  }

  showReportsModal() {
    this.getallReports();
    document.getElementById('goToReportsBtn').click();
  }

  // for message side drawer functions
  toggleMessageDrawer() {
    this.isDrawerOpen = !this.isDrawerOpen;
    if (this.isDrawerOpen) this.getAllMessagesWithCount();
    else this.messages = [];
  }

  getAllMessagesWithCount() {
    this.messagesLoading = true;
    const startTime = new Date(this.startTime);
    const endTime = new Date(this.endTime);
    const start = `${startTime.getFullYear()}-${startTime.getMonth() + 1}-${startTime.getDate()}`;
    const end = `${endTime.getFullYear()}-${endTime.getMonth() + 1}-${endTime.getDate()}`;
    this.reportsService.getVehicleMessageData(this.vehicle.deviceId, start, end).subscribe({
      next: res => {
        // find all the distinct messages
        if (res.length) {
          const list = [];
          res.forEach(item => {
            for (var k in item) {
              if (k !== 'date' && k !== 'NO_DATA') {
                const obj = { message: '', color: '', count: 0 };
                if (item[k]) {
                  obj.message = k;
                  obj.count = item[k];
                  if (this.messageTypeColor[k]) obj.color = this.messageTypeColor[k].colorOpaque;
                  else obj.color = this.messageTypeColor['UNKNOWN'].colorOpaque;
                  list.push(obj);
                }
              }
            }
          });
          this.messages = list;
        } else {
          this.messages = [];
          this.clearAllMessageMarkers();
        }
        this.messagesLoading = false;
      },
      error: error => {
        this.messagesLoading = false;
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  plotMessageMarkers(messageObj) {
    if (!this.selectedMessages.includes(messageObj.message)) {
      this.selectedMessages.push(messageObj.message);
      this.getMessageHistory(this.vehicle.deviceId, this.startTime, this.endTime, messageObj.message);
    } else {
      this.selectedMessages.splice(this.selectedMessages.indexOf(messageObj.message), 1);
      this.clearMessageMarkers(messageObj.message);
    }
  }

  getMessageHistory(deviceId, startTime, endTime, messageType) {
    const attributes = 'messageType,eventTime,latitude,longitude,heading';
    this.liveService.getSingleVehicleMessage(deviceId, this.page, attributes, startTime, endTime, 1000, messageType)
      .subscribe(res => {
        if (res.length) {
          const img = '';
          const markerArray = [];
          res.forEach(m => {
            const marker = this.addMessageMarker(m.latitude, m.longitude, img);
            markerArray.push(marker);
          });
          this.messageMarkers[messageType] = markerArray;
        }
      }, error => {
        this.isLoading = false;
        this.sharedService.getErrorMsg(error);
      });
  }

  addMessageMarker(lat, long, img) {
    const latlng = new google.maps.LatLng(lat, long);
    const marker = new google.maps.Marker({
      position: latlng,
      map: this.map,
      // label: eventDate,
      // icon: img
    });
    this.setAnimation(marker);
    return marker;
  }

  // Set Animation
  setAnimation(marker) {
    marker.setAnimation(google.maps.Animation.DROP);
    setTimeout(function () { marker.setAnimation(null); }, 750);
  }

  clearMessageMarkers(messageType) {
    for (let i = 0; i < this.messageMarkers[messageType].length; i++) {
      this.messageMarkers[messageType][i].setMap(null);
    }
  }

  clearAllMessageMarkers() {
    for (var k in this.messageMarkers) {
      if (this.messageMarkers[k] && this.messageMarkers[k].length) {
        this.clearMessageMarkers(k);
      }
    }
  }

  addBounds(data) {
    let bounds = new google.maps.LatLngBounds();
    data.forEach(item => {
      if (item.latitude && item.longitude) {
        // to extends the bounds
        bounds.extend(new google.maps.LatLng(item.latitude, item.longitude));
      }
    });
    this.map.fitBounds(bounds);
  }

  onTimeSelection(val) {
    this.pageVehicleHistory = 0;
    this.pageInfo.offset = 0;
    if (this.timeSeeker.selectedVal.includes(val.ts)) {
      const index = this.timeSeeker.selectedVal.indexOf(val.ts);
      this.timeSeeker.selectedVal.splice(index, 1);
      this.timeSeeker.selected = false;
      this.getMessages(this.vehicle.deviceId, this.startTime, this.endTime, this.searchModel.messageType);
      this.getTestCount(this.startTime, this.endTime);
    } else if (this.timeSeeker.selectedVal.length < 1 || this.timeSeeker.selectedVal.length === 1) {
      this.timeSeeker.selectedVal = [];
      this.timeSeeker.selected = true;
      this.timeSeeker.ts = val.ts;
      this.timeSeeker.te = val.te;
      this.getMessages(this.vehicle.deviceId, val.ts, val.te, this.searchModel.messageType);
      this.getTestCount(val.ts, val.te);
      this.timeSeeker.selectedVal.push(val.ts);
    }
  }

  getMessages(deviceId, startTime, endTime, messageType?) {
    this.liveService.getSingleVehicleMessage(
      deviceId, this.pageVehicleHistory, this.liveHistorykeyString, startTime, endTime, this.resSize, this.searchModel.messageType
    ).subscribe(res => {
      this.ngzone.run(() => {
        if (res.length > 0) {
          this.historyRowsEmpty = false;
          // if (this.timeSeeker.selected) {
          //   this.historyRows = res;
          // } else {
          //   this.historyRows = [...this.historyRows, ...res];
          // }
          if (this.pageVehicleHistory === 0) {
            this.historyRows = res;
          } else {
            this.historyRows = [...this.historyRows, ...res];
          }
          this.vehicle.trips = this.historyRows;
          this.vehicle.trips = this.vehicle.trips.map(data => {
            if (data.vehicleSpeed && !Number.isInteger(data.vehicleSpeed)) {
              let newvehicleSpeed = data.vehicleSpeed;
              data.vehicleSpeed = parseFloat(newvehicleSpeed).toFixed(1);
            }
            var messageValue = configMessage.messageType[data.messageType];
            if (!messageValue) {
              messageValue = data.messageType;
            }
            data.activity = messageValue;
            return data;
          });
          // To set page Count
          this.setPageInfo();
          this.prevResponse = res.length;
          this.pageCount = res.length;
          this.loadingIndicator = false;
        } else {
          if (!this.pageVehicleHistory) {
            this.historyRowsEmpty = true;

            this.currentPageCount = {
              start: 0,
              end: 0
            };
          }
          this.pageCount = 0;
          this.historyRowsEmpty = true;
          this.historyRows = [];
          this.prevResponse = 0;
        }
        // if(this.searchModel.messageType) {
        //   this.locationTotalCount.count = 0;
        // }
      });
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }
  resetTimeSeeker() {
    this.timeSeeker = {
      selected: false,
      ts: null,
      te: null,
      selectedVal: [],
      len: 0
    };
  }
  onPIDClick(e) {
    this.graphContainerParams = e;
  }
}
